import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Masthead from './components/Masthead';
import Home from './pages/Home';
import ArticlePage from './pages/ArticlePage';
import OurMission from './pages/OurMission';
import Journalists from './pages/Journalists';
import JournalistProfile from './pages/JournalistProfile';
import Publications from './pages/Publications';
import Subscribe from './pages/Subscribe';
import AboutUs from './pages/AboutUs';
import Blog from './pages/Blog';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { XIcon, InstagramIcon } from './components/SocialIcons';
import footerLogo from './assets/footer-logo.png';

export default function App() {
  return (
    <div className="app">
      <Masthead />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/articles/:id" element={<ArticlePage />} />
        <Route path="/our-mission" element={<OurMission />} />
        <Route path="/journalists" element={<Journalists />} />
        <Route path="/journalists/:id" element={<JournalistProfile />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
      <footer className="footer">
        <div className="footer__inner">
          <div className="footer__social">
            <h3 className="footer__social-heading">Follow Us</h3>
            <div className="footer__social-links">
              <a
                href="https://x.com/onlyfreenews1"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
                aria-label="Follow OnlyFreeNews on X"
              >
                <XIcon />
              </a>
              <a
                href="https://www.instagram.com/onlyfreenews"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
                aria-label="Follow OnlyFreeNews on Instagram"
              >
                <InstagramIcon />
              </a>
            </div>
          </div>
          <img src={footerLogo} alt="OnlyFreeNews" className="footer__logo" />
          <div className="footer__links">
            <Link to="/about" className="footer__link">
              About Us
            </Link>
            <Link to="/terms" className="footer__link">
              Terms of Use
            </Link>
            <Link to="/privacy" className="footer__link">
              Privacy Policy
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
